module.exports = __webpack_public_path__ + "img/A_contrast.52b5e0e3.svg";